import React from 'react';
import LeftBar from "../../components/left-bar/LeftBar";
import NavigationLinks from "../../components/navigation-links/NavigationLinks";
import Content from "../../components/content/Content";
import ActionButton from "../../components/button/ActionButton";
import messageDialogActions from '../../components/dialogs/messageDialog-acions';
import {connect} from "react-redux";
import {
    navLinks,
    getSpendingTypes,
    getDebt, saveDebt, deleteDebt, createDealForDebt, importDebts, debtLevels, debtPaymentTypes
} from "../../services/moneyFlow";
import AnyField from "../../components/fields/AnyField";
import {DialogActions, DialogContent, Grid, MenuItem} from "@material-ui/core";
import { emptyMoney} from "../../services/common";
import { processMomentFieldInObject } from "../../utils/moment-utils";
import infoActions from "../../components/info/info-actions";
import {
    getHumanEmployees,
    getExternalSubjects,
    getJuridicalPersons,
    getCheckingAccounts
} from "../../services/organization";
import AutocompleteSelectField from "../../components/fields/AutocompleteSelectField";
import {getPaymentTypes} from "../../services/sale";
import _ from "lodash";
import MoneyField from "../../components/fields/MoneyField";
import {getBusinessUnitByRole, hasRole} from "../../services/user";
import {withTranslation} from "react-i18next";
import SelectFromItemsField from "../../components/fields/SelectFromItemsField";
import moment from "moment";
import DealsByReason from "./DealsByReason";
import confirmDialogActions from "../../components/dialogs/confirmDialog-acions";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import ShowField from "../../components/fields/ShowField";
import DateMonthField from "../../components/fields/DateMonthField";
import ImportDialog from "../../components/dialogs/ImportDialog";
import DateTimeField from "../../components/fields/DateTimeField";
import {moneyFlowKeys} from "../../entities/importKeys";

export default
@connect(state => ({
    currentParlour: state.common.currentParlour,
}),{
    showInfo: infoActions.show,
    showMessage: messageDialogActions.show,
    showConfirm: confirmDialogActions.show
})
@withTranslation()
class DebtViewPage extends React.Component {
    state = {
        externalSubjects: [],
        businessUnits: [],
        spendingTypes: [],
        paymentTypes: [],
        debt: {
            id: null,
            amount: {...emptyMoney},
            currentAmount: {...emptyMoney},
            businessUnitId: null,
            comment: null,
            paymentType: null,
            externalSubjectId: null,
            reasonId: null,
            employeeId: null,
            applyAt: moment().add(-10, 'days').endOf('months').startOf('day'),
            lvl: null,
            juridicalPersonId: null,
            companyEmployeeId: null
        },
        employees: [],
        companyEmployees: [],
        createDialogOpen: false,
        deal: {
            amount: {...emptyMoney},
            employeeId: null,
            externalSubjectId: null,
            companyEmployeeId: null,
            cancellationFact: null,
            juridicalPersonId: null,
            checkingAccountId: null,
            paymentType: null
        },
        refreshDeals: false,
        openImportModal: false,
        trustedJuridicalPersons: [],
        dealJuridicalPersons: [],
        dealCheckingAccounts: []
    };

    componentDidMount() {
        const path = this.props.location.pathname;
        const reId = new RegExp('[^/]+$');
        const resultId = reId.exec(path);
        if (resultId.length && resultId[0] !== '0') {
            this.loadDebt(resultId[0]);
        }

        if (this.props.currentParlour) {
            this.setState({
                debt: {
                    ...this.state.debt,
                    businessUnitId: this.props.currentParlour.id,
                },
            }, this.getTrustedJuridicalPersons)
        }

        getExternalSubjects()
            .then(response => {
                if (response.success) {
                    this.setState({
                        externalSubjects: [
                            ...response.data
                        ],
                    });
                }
            });

        getBusinessUnitByRole('ROLE_MONEYFLOW_DEBT_SAVE')
            .then(response => {
                if (response.success) {
                    this.setState({
                        businessUnits: [
                            ...response.data
                        ],
                    });
                }
            });

        getSpendingTypes()
            .then(response => {
                if (response.success) {
                    this.setState({
                        spendingTypes: [
                            ...response.data
                        ],
                    });
                }
        });

        getPaymentTypes().then(response => {
            if (response.success) {
                this.setState({
                    paymentTypes: _.filter(response.data, function(o) {
                        return debtPaymentTypes.includes(o.id);
                    })
                });
            }
        });

        getHumanEmployees({'canHaveMoney': true})
            .then(response => {
                if (response.success) {
                    this.setState({
                        employees: response.data,
                    });
                }
            });

        getHumanEmployees()
            .then(response => {
                if (response.success) {
                    this.setState({
                        companyEmployees: response.data,
                    });
                }
            });
    }

    loadDebt = debtId => {
        getDebt(debtId)
            .then(response => {
                if (response.success) {
                    this.setState({
                        debt: response.data
                    }, this.getTrustedJuridicalPersons);
                }
            });
    };

    getTrustedJuridicalPersons = () => {
        getJuridicalPersons({'trustedForBusinessUnit': this.state.debt.businessUnitId})
            .then(response => {
                if (response.success) {
                    this.setState({
                        trustedJuridicalPersons: response.data,
                    });
                }
            });
    }

    handleChange = prop => event => {
        let {value} = event.target
        const {debt, spendingTypes} = this.state;

        if(prop === 'reasonId') {
            debt.lvl = spendingTypes.find(spendingType => spendingType.id === value).debtLvl
        }

        this.setState({
            debt: {
                ...debt,
                [prop]: value,
            }
        }, () => {
            if( prop === 'businessUnitId') {
                this.getTrustedJuridicalPersons();
            }
        });
    };

    handleSave = () => {
        saveDebt(processMomentFieldInObject(this.state.debt, 'applyAt'))
            .then(response => {
                if (response.success) {
                    this.props.history.push(`/money-flow/debt`);
                } else {
                    this.props.showMessage(response.error ? response.error.message : response.message);
                }
            });
    };

    handleDelete = () => {
        const { t } = this.props;

        this.props.showConfirm({
            message: t('Do you really want to remove the debt'),
            title: t('Debt deleting'),
            onClose: ok => {
                if (ok) {
                    deleteDebt(this.state.debt.id)
                        .then(response => {
                            if (response.success) {
                                this.props.history.push(`/money-flow/debt`);
                            } else {
                                this.props.showMessage(response.error ? response.error.message : response.message);
                            }
                        });
                }
            }
        });
    };

    handleCreateDeal = () => {
        const { debt } = this.state;
        this.setState({
            deal: {
                amount: {...debt.currentAmount},
                employeeId: debt.employeeId,
                externalSubjectId: debt.externalSubjectId,
                companyEmployeeId: debt.companyEmployeeId,
                cancellationFact: null,
                juridicalPersonId: debt.juridicalPersonId,
                checkingAccountId: null,
            },
            createDialogOpen: true
        },
            this.fetchDealCheckingAccounts
        );
    };

    handleChangeDeal = prop => event => {
        let value;

        if (event instanceof moment) {
            value = event;
        } else {
            value = event.target.value;
        }

        if (prop === 'paymentType') {
            this.setState({
                debt: {
                    ...this.state.debt,
                    paymentType: value
                }
            })
        }

        this.setState({
                    deal: {
                        ...this.state.deal,
                        [prop]: value,
                    }
                },
            () => {
                    if (prop === 'juridicalPersonId') {
                        this.resetDealCheckingAccountId()
                        this.fetchDealCheckingAccounts()
                    }
                });
    };

    fetchDealCheckingAccounts = () => {
        const { deal } = this.state

        if (deal.juridicalPersonId) {
            getCheckingAccounts({juridicalPersonId: deal.juridicalPersonId, active: true})
                .then((response) => {
                    this.setState(
                        {
                            dealCheckingAccounts: response.data,
                        }
                    )
                })
        }
    }

    resetDealCheckingAccountId = () => {
        this.setState(
            {
                deal: {
                    ...this.state.deal,
                    checkingAccountId: null
                }
            }
        )
    }

    handleCloseDealDialog = ok => () => {
        const { debt, deal } = this.state;

        if (!ok) {
            this.setState({
                createDialogOpen: false,
            });
            return;
        }

        createDealForDebt({
            ...deal,
            employeeId: deal.employeeId === -1 ? null : deal.employeeId,
            debtId: debt.id
        })
            .then(response => {
                if (response.success) {
                    this.setState({
                        createDialogOpen: false,
                        refreshDeals: !this.state.refreshDeals,
                    });
                    this.loadDebt(debt.id);
                } else {
                    this.props.showMessage(response.error ? response.error.message : response.message);
                }
            })
    };

    handleImportDebts = () => {
        this.setState({ openImportModal: true });
    }

    render() {
        const { t } = this.props;
        const {
            debt,
            externalSubjects,
            businessUnits,
            spendingTypes,
            paymentTypes,
            employees,
            companyEmployees,
            createDialogOpen,
            deal,
            refreshDeals,
            openImportModal,
            trustedJuridicalPersons,
            dealCheckingAccounts
        } = this.state;

        const debtCreateDisabled =
            !debt.businessUnitId ||
            !debt.reasonId ||
            !debt.paymentType ||
            !debt.amount.val ||
            (debt.paymentType === 'cashless' && !debt.externalSubjectId) ||
            !debt.juridicalPersonId

        const dealCreateDisabled =
            (debt.paymentType === 'cash' && !deal.employeeId) ||
            (debt.paymentType === 'cashless' && (!deal.externalSubjectId || !deal.checkingAccountId)) ||
            !deal.cancellationFact ||
            !deal.juridicalPersonId ||
            !deal.paymentType

        let selectedBusinessUnit = businessUnits.find((item) => debt.businessUnitId === item.id);
        let currencies = selectedBusinessUnit ? [selectedBusinessUnit.mainCurrency] : [emptyMoney.cur];

        return(
            <React.Fragment>
                <LeftBar navigationLinks={<NavigationLinks links={navLinks}/>}>
                    <ShowField
                        label={t('Current sum')}
                        value={debt.currentAmountFormat}
                        visible={Boolean(debt.id)}
                    />
                    <ActionButton onClick={this.handleSave} visible={hasRole('ROLE_MONEYFLOW_DEBT_SAVE')} disabled={debtCreateDisabled}>{t('Save')}</ActionButton>
                    <ActionButton onClick={this.handleCreateDeal} visible={hasRole('ROLE_MONEYFLOW_DEBT_WRITEOFF')} disabled={!(debt.id && debt.currentAmount && debt.currentAmount.val > 0)}>{t('Write off debt')}</ActionButton>
                    <ActionButton onClick={this.handleDelete} visible={hasRole('ROLE_MONEYFLOW_DEBT_SAVE')} disabled={!debt.id}>{t('Delete')}</ActionButton>
                    <ActionButton onClick={this.handleImportDebts} visible={hasRole('ROLE_MONEYFLOW_DEBT_SAVE')}>{t("Import debts")}</ActionButton>
                </LeftBar>
                <Content title={t("Debt card")}>
                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            <SelectFromItemsField
                                items={businessUnits}
                                label={t("Business unit")}
                                value={debt.businessUnitId}
                                required
                                error={!debt.businessUnitId}
                                onChange={this.handleChange('businessUnitId')}
                                fullWidth
                                readOnly={Boolean(debt.id)}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <AutocompleteSelectField
                                label={t("Spending type")}
                                value={debt.reasonId}
                                required
                                error={!debt.reasonId}
                                onChange={this.handleChange('reasonId')}
                                fullWidth
                                options={spendingTypes.map(item => ({value: item.id, label: `${item.name} / ${item.category.name}`}))}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            <AnyField
                                id="type"
                                value={debt.paymentType}
                                error={!debt.paymentType}
                                onChange={this.handleChange('paymentType')}
                                select
                                label={t("Payment type")}
                                required
                                fullWidth
                                readOnly={Boolean(debt.id)}>
                                {paymentTypes.map(item => <MenuItem key={item.id} value={item.id}>{item.text}</MenuItem>)}
                            </AnyField>
                        </Grid>
                        <Grid item xs={3}>
                            <MoneyField
                                label={t('Sum')}
                                currencies={ currencies }
                                value={ debt.amount }
                                error = { !debt.amount }
                                onChange={this.handleChange('amount')}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <AutocompleteSelectField
                                label={t("From juridical person")}
                                value={debt.juridicalPersonId}
                                error={!debt.juridicalPersonId}
                                onChange={this.handleChange('juridicalPersonId')}
                                fullWidth
                                options={trustedJuridicalPersons.map(item => ({value: item.id, label: `${item.fullName}`}))}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <AutocompleteSelectField
                                label={t("External subject")}
                                value={debt.externalSubjectId}
                                required
                                error={debt.paymentType === 'cashless' && !debt.externalSubjectId}
                                onChange={this.handleChange('externalSubjectId')}
                                fullWidth
                                options={externalSubjects.map(item => ({value: item.id, label: `${item.name}`}))}
                            />
                        </Grid>
                        {debt.paymentType === 'cash' && hasRole('ROLE_MONEYFLOW_DEAL_SPENDINGFROMEMPLOYEE') &&
                        <Grid item xs={3}>
                            <AutocompleteSelectField
                                label={t("Employee's money")}
                                value={debt.employeeId}
                                onChange={this.handleChange('employeeId')}
                                fullWidth
                                options={employees.map(item => ({value: item.id, label: `${item.name}`}))}
                                isClearable
                            />
                        </Grid>
                        }
                        <Grid item xs={3}>
                            <AutocompleteSelectField
                                label={t("Company employee")}
                                value={debt.companyEmployeeId}
                                onChange={this.handleChange('companyEmployeeId')}
                                fullWidth
                                options={companyEmployees.map(item => ({value: item.id, label: `${item.name}`}))}
                                isClearable
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            <AnyField
                                label={t("Comment")}
                                value={debt.comment}
                                onChange={this.handleChange('comment')}
                                multiline
                                rows={4}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <DateMonthField
                                label={t("Account for the month")}
                                onChange={this.handleChange('applyAt')}
                                value={debt.applyAt}
                                fullWidth
                            />
                            <SelectFromItemsField
                                items={debtLevels}
                                label={t("Level")}
                                value={debt.lvl}
                                onChange={this.handleChange('lvl')}
                                fullWidth
                                nullValue={1}
                                nullableText="1"
                            />
                        </Grid>
                    </Grid>
                    {debt.id ?
                        <Grid container spacing={2}>
                            <Grid item xs={12}>Списания</Grid>
                            <Grid item xs={12}>
                                <DealsByReason
                                    reasonId={debt.id}
                                    refreshTable={refreshDeals}
                                />
                            </Grid>
                        </Grid>
                        : null
                    }
                    <Dialog
                        open={createDialogOpen}
                        onClose={this.handleCloseDealDialog(false)}
                    >
                        <DialogTitle>{t('Create deal')}</DialogTitle>
                        <DialogContent style={{minHeight: 400, width: 400}}>
                            <MoneyField
                                label={t('Sum')}
                                currencies={ currencies }
                                value={ deal.amount }
                                error = { !deal.amount }
                                onChange={this.handleChangeDeal('amount')}
                                fullWidth
                            />
                            <AnyField
                                value={deal.paymentType}
                                error={!deal.paymentType}
                                onChange={this.handleChangeDeal('paymentType')}
                                select
                                label={t("Payment type")}
                                required
                                fullWidth
                            >
                                {paymentTypes.map(item => <MenuItem key={item.id} value={item.id}>{item.text}</MenuItem>)}
                            </AnyField>
                            <AutocompleteSelectField
                                label={t("Juridical person")}
                                value={deal.juridicalPersonId}
                                required
                                error={!deal.juridicalPersonId}
                                onChange={this.handleChangeDeal('juridicalPersonId')}
                                fullWidth
                                options={trustedJuridicalPersons.map(item => ({value: item.id, label: `${item.shortName}`}))}
                            />
                            <AutocompleteSelectField
                                label={t("External subject")}
                                value={deal.externalSubjectId}
                                required
                                error={debt.paymentType === 'cashless' && !deal.externalSubjectId}
                                onChange={this.handleChangeDeal('externalSubjectId')}
                                fullWidth
                                options={externalSubjects.map(item => ({value: item.id, label: `${item.name}`}))}
                            />
                            {debt.paymentType === 'cashless' &&
                                <AutocompleteSelectField
                                    label={t("Checking account")}
                                    value={deal.checkingAccountId}
                                    required
                                    error={!deal.checkingAccountId}
                                    onChange={this.handleChangeDeal('checkingAccountId')}
                                    fullWidth
                                    options={dealCheckingAccounts.map(item => ({value: item.id, label: `${item.bankName + ' / ' + item.juridicalPersonShortName}`}))}
                                />
                            }
                            {debt.paymentType === 'cash' && hasRole('ROLE_MONEYFLOW_DEAL_SPENDINGFROMEMPLOYEE') &&
                                <SelectFromItemsField
                                    label={t("Write off from")}
                                    value={deal.employeeId}
                                    onChange={this.handleChangeDeal('employeeId')}
                                    fullWidth
                                    required
                                    error={debt.paymentType === 'cash' && !deal.employeeId}
                                    items={[
                                        { id: -1, name: t("Business unit cashbox")},
                                        ...employees
                                    ]}
                                />
                            }
                            <AutocompleteSelectField
                                label={t('Company employee')}
                                value={deal.companyEmployeeId}
                                onChange={this.handleChangeDeal('companyEmployeeId')}
                                fullWidth
                                options={companyEmployees.map(item => ({value: item.id, label: `${item.name}`}))}
                            />
                            <DateTimeField
                                label={t("Cancellation fact")}
                                value={deal.cancellationFact}
                                fullWidth
                                required
                                onChange={this.handleChangeDeal('cancellationFact')}
                                disabled={false}
                                error={!deal.cancellationFact}
                            />
                        </DialogContent>
                        <DialogActions>
                            <ActionButton
                                onClick={this.handleCloseDealDialog(true)}
                                disabled={dealCreateDisabled}
                            >{t('OK')}</ActionButton>
                            <ActionButton onClick={this.handleCloseDealDialog(false)}>{t('Cancel')}</ActionButton>
                        </DialogActions>
                    </Dialog>
                </Content>
                {openImportModal && <ImportDialog
                    open={openImportModal}
                    onClose={() => this.setState({openImportModal: false})}
                    title={t("Import debts")}
                    importFunc={importDebts}
                    keys={moneyFlowKeys}
                    chunk={10000}/> }
            </React.Fragment>
        );
    }
}
